import axios from 'axios'

const apiClient = axios.create({
  baseURL: `${process.env.VUE_APP_CONNECTION_URL}`,
  withCredentials: false,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
})

export default {
  async updateSkillLevel (idToken, obj) {
    return await apiClient.post('skilllevel/', obj,
      {
        headers: { idToken: idToken }
      })
  },
  async getSkillLevel () {
    return await apiClient.get('skilllevel/')
  },
  async newDiscount (idToken, obj) {
    return await apiClient.post('recarga/', obj,
      {
        headers: { idToken: idToken }
      })
  },
  async updateRecarga (idToken, obj, id_recarga) {
    return await apiClient.put(`recarga/${id_recarga}`, obj,
      {
        headers: { idToken: idToken }
      })
  },
  async getRecargas () {
    return await apiClient.get('recarga/')
  },
  async getRecarga (id_recarga) {
    return await apiClient.get(`recarga/${id_recarga}`)
  },
  async deleteRecarga (idToken, id_recarga) {
    return await apiClient.delete(`recarga/${id_recarga}`,
    {
      headers: { idToken: idToken }
    })
  }
}
